import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_PetPolicy = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_PetPolicy' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Pet Policy</h3></p>

                <p className='w-750'>
                    It is policy of Lilly Pad Home Health, LLC to ensure the safety of persons served, staff members, 
                    visitors, and property. The right of persons served, staff members, and visitors to work in a place; 
                    whether in Lilly Pad Home Health facility or the home of a recipient, free of animal threat, hair and 
                    dander is the governing principles.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    <h4>I. Procedures:</h4>
                </p>
                <p className='w-750'>
                    <h4>Office Areas:</h4>
                </p>
                <ol type='A'>
                    <li>
                        Only certified service pets are allowed on Lilly Pad Home Health premises.

                    </li>
                    <li>Pets must be registered in accordance with the owner's local regulations.

                        Pet owner must have current shot/vaccination documentation before pet is allowed on premises.
                    </li>
                    <li>Pet owners are personally rersponsible for any injuries caused to individuals
                        or any damage caused to buildings. The pet owner is financially

                        responsible for any damage to the property of Lilly Pad Home Health or individuals caused the pet.
                    </li>
                    <li>Pet owners are expected to clean up after their pets and not cause any additional
                        work for custodial or maintenance personnel. Maintenance, security

                        and custodial services will not enter any office where there is a pet present.
                    </li>
                    <li>
                        Pet owner is responsible for cleaning up any waste left by his/her, both inside and outside buildings.

                    </li>
                    <li>All pets are to be secured behing a closed locked door before entrance of a

                        representative from Lilly Pas Home Health in the home unless pet is a certified service pet.
                    </li>
                    <li>Recipients that use certified service pets must submit a copy of

                        certification to Lilly Pad Home Health upn entry into services.
                    </li>
                    <li>
                        Lilly Pad Home Health upon knocking will ask if there is a pet present.

                    </li>
                    <li>
                        If 'Yes' Lilly Pad Home Health staff before entrance will ask if the pet has been locked behing a closed door.

                    </li>
                    <li>
                        Only after an answer of 'Yes', will Lilly Pad Home Health staff enter the residence.

                    </li>
                    <li>
                        Pet is to remain behing closed locked door until staff member has left the premises.

                    </li>
                </ol>

                <table>
                    <tr>
                        <td className='signature w-750'></td>
                    </tr>
                    <tr>
                        <td className='small w-750 '>Name of Client</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Recipient Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Witness:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











